import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-animate_rect",
  "use": "icon-animate_rect-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-animate_rect\">\n<path d=\"M21.4697 10C21.7626 10 22 10.2374 22 10.5303V21.4697C22 21.7626 21.7626 22 21.4697 22H10.5303C10.2374 22 10 21.7626 10 21.4697V10.5303C10 10.2374 10.2374 10 10.5303 10H21.4697Z\" stroke=\"#81818A\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol